import { t } from "../i18n";

export function getWebrootLicenseDescription(licenseCategory: string): string | undefined {
  return t(`Brand.${licenseCategory}`);
}
export interface IWebrootProductNames {
  licenseCategory: string;
  description: string;
  sku: string;
  candyRackDescription: string[];
}

export const webrootLicenseCategories = {
  WSAV: "WSAV",
  WSAI: "WSAI",
  WSAC: "WSAC",
  WSAFMPK: "WSAFMPK",
  WSCB: "WSCB",
  WSAG: "WSAG",
  WIFI: "WIFI",
  WSAP: "WSAP",
  WSID: "WSID",
  WSAPF: "WSAPF",
  WSIDP: "WSIDP",
  WSIDPF: "WSIDPF",
  CD: "CD",
};

export const webrootSKUs = ["WSAV", "WSAI", "WSAC", "WSAFMPK", "WSCB", "WSAG", "WIFI", "WSAP", "WSID", "WSAPF"];
export const allstateSKUs = ["WSAP", "WSAPF", "WSID", "WSIDP", "WSIDPF"];
export const premiumSKUs = ["WSAP", "WSAPF"];
export const nonAllstateWebrootSKUs = ["WSAV", "WSCB", "WSAG", "WIFI", "WSAC", "WSAFMPK", "WSAI"];
export const addOns = ["WSID", "WSIDP", "WSIDPF"];
export const webrootCD = "WebrootSoftwareInstallationCD";
export const webrootProducts: IWebrootProductNames[] = [
  {
    licenseCategory: webrootLicenseCategories.WSAV,
    description: "Webroot AntiVirus",
    sku: "WebrootAntiVirus",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSAI,
    description: "Webroot SecureAnywhere Internet Security Plus",
    sku: "WebrootPlus",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSAC,
    description: "Webroot SecureAnywhere Internet Security Complete",
    sku: "WebrootGamer",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSAFMPK,
    description: "Webroot SecureAnywhere Complete Family",
    sku: "WebrootComplete",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSCB,
    description: "Webroot for Chromebook",
    sku: "WebrootChromebook",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSAG,
    description: "Webroot SecureAnywhere Antivirus for PC Gamers",
    sku: "WebrootGamer",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WIFI,
    description: "Webroot WiFi Security",
    sku: "WebrootSecureVPN",
    candyRackDescription: [
      "SpecialOffers.WebrootWiFiSecurityDescription1",
      "SpecialOffers.WebrootWiFiSecurityDescription2",
    ],
  },
  {
    licenseCategory: webrootLicenseCategories.WSAP,
    description: "Webroot Premium",
    sku: "WebrootPremium",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSAPF,
    description: "Webroot Premium Family",
    sku: "WebrootPremiumFamily",
    candyRackDescription: [],
  },
  {
    licenseCategory: webrootLicenseCategories.WSID,
    description: "Identity Protection Add-On",
    sku: "AllstateIdentityProtectionAddOn",
    candyRackDescription: [
      "SpecialOffers.AllstateIdentityProtectionAddOnDescription1",
      "SpecialOffers.AllstateIdentityProtectionAddOnDescription2",
      "SpecialOffers.AllstateIdentityProtectionAddOnDescription3",
    ],
  },
  {
    licenseCategory: webrootLicenseCategories.WSIDP,
    description: "Identity Protection Add-On Premium",
    sku: "AllstateIdentityProtectionAddOnPremium",
    candyRackDescription: [
      "SpecialOffers.AllstateIdentityProtectionAddOnPremiumDescription1",
      "SpecialOffers.AllstateIdentityProtectionAddOnPremiumDescription2",
      "SpecialOffers.AllstateIdentityProtectionAddOnPremiumDescription3",
    ],
  },
  {
    licenseCategory: webrootLicenseCategories.WSIDPF,
    description: "Identity Protection Add-On Family",
    sku: "AllstateIdentityProtectionAddOnPremiumFamily",
    candyRackDescription: [
      "SpecialOffers.AllstateIdentityProtectionAddOnPremiumFamilyDescription1",
      "SpecialOffers.AllstateIdentityProtectionAddOnPremiumFamilyDescription2",
      "SpecialOffers.AllstateIdentityProtectionAddOnPremiumFamilyDescription3",
    ],
  },
  {
    licenseCategory: webrootLicenseCategories.CD,
    description: "Webroot Software Installation CD",
    sku: "WebrootSoftwareInstallationCD",
    candyRackDescription: [],
  },
];

export const webrootSkusWithNotableFeature = [
  "WebrootAntiVirus",
  "WebrootGamer",
  "WebrootPlus",
  "WebrootComplete",
  "WebrootPremium",
  "WebrootPremiumFamily",
  "WebrootChromebook",
  "WebrootSecureVPN",
];
export const webrootMultiDeviceSkus = [
  "WebrootPlus",
  "WebrootComplete",
  "WebrootPremium",
  "WebrootPremiumFamily",
  "WebrootChromebook",
  "WebrootSecureVPN",
];
export const webrootSkusWithIdentity = ["WebrootPremium", "WebrootPremiumFamily"];
